import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("Please enter your email."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Thanks for submitting! You're on the list.");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-konattu-red py-20 md:py-28" data-testid="newsletter-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="font-mono text-xs tracking-[0.35em] text-konattu-yellow">/ NEWSLETTER</span>
          <h2 className="mt-5 font-display font-bold text-white tracking-tight leading-[0.95] text-4xl md:text-6xl">
            Stay in the know.
          </h2>
          <p className="mt-5 font-body text-white/80 text-lg max-w-md">
            Be first to hear about Mood Offers, lucky draws and new store openings across Kerala.
          </p>
        </div>
        <form onSubmit={submit} data-testid="newsletter-form" className="flex items-end gap-4">
          <div className="flex-1">
            <label className="font-mono text-[11px] tracking-[0.3em] text-white/70">EMAIL</label>
            <input
              data-testid="newsletter-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email here"
              className="w-full bg-transparent border-0 border-b border-white/40 rounded-none py-3 mt-2 font-body text-white placeholder:text-white/50 focus:outline-none focus:border-konattu-yellow transition-colors"
            />
          </div>
          <button type="submit" disabled={loading} data-testid="newsletter-submit" className="group inline-flex items-center gap-2 bg-konattu-charcoal text-white px-7 py-3.5 text-sm font-medium tracking-wide hover:bg-black transition-colors disabled:opacity-60 whitespace-nowrap">
            {loading ? "..." : "Sign Up"}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
